export enum NotificationType {
  AT_MENTION = 8,
}
